import { unescape } from 'html-escaper';
import { CustomerModel, PartnerProductModel, PartnerShopModel, FileModel } from '.';
import { translate } from '../helpers/frontend';

export class PartnerProductRatingModel {
  constructor(data={}) {
    this._id = data._id? data._id: null;

    this.order = {
      _id: data?.order?._id || null,
      orderId: data?.order?.orderId || null,
    };
    this.customer = new CustomerModel(data?.customer || {});
    this.shop = new PartnerShopModel(data?.shop || {});

    this.products = data.products?.length? data.products.map(d => new PartnerProductModel(d)): [];
    this.productIds = this.products.map(d => d._id);
    
    this.rating = data.rating? Number(data.rating): null;
    this.comment = data.comment? unescape(data.comment): null;
    this.images = data.images?.length? data.images.map(d => new FileModel(d)): [];

    this.isShown = data.isShown? Number(data.isShown): 0;
    this.isAnonymous = data.isAnonymous? Number(data.isAnonymous): 0;
    
    this.createdAt = data.createdAt || null;
    this.updatedAt = data.updatedAt || null;
  }
  
  isValid() {
    return this._id? true: false;
  }
  isValidOrder() {
    return this.isValid() && this.order._id? true: false;
  }

  displayStatus(langObj={}) {
    if(this.isValid()){
      if(this.isShown === 1) return (<span className="ss-tag bg-success">{translate('Show', langObj)}</span>);
      else return (<span className="ss-tag bg-warning">{translate('Hide', langObj)}</span>);
    }else{
      return (<span className="ss-tag bg-warning">{translate('Hide', langObj)}</span>);
    }
  }
  displayAnonymous(langObj={}) {
    if(this.isValid()){
      if(this.isAnonymous === 1) return (<span className="ss-tag bg-success">{translate('Yes', langObj)}</span>);
      else return (<span className="ss-tag bg-warning">{translate('No', langObj)}</span>);
    }else{
      return (<span className="ss-tag bg-warning">{translate('No', langObj)}</span>);
    }
  }
}
